import { styled } from '@mui/material/styles';
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  alpha,
} from '@mui/material';

export const StyledCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const StyledCardContent = styled(CardContent)(({ theme }) => ({
  // Padding ya viene por defecto de CardContent
}));

export const CardHeader = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
}));

export const CardTitle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  fontWeight: 600,
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
}));

export const StyledTable = styled(Table)(({ theme }) => ({
  // Table por defecto
}));

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  '& .MuiTableCell-root': {
    color: theme.palette.text.secondary,
    fontWeight: 600,
    fontSize: '0.95rem',
    letterSpacing: 0.8,
    textTransform: 'capitalize',
    borderBottom: `1px solid ${theme.palette.divider}`,
    background: 'transparent',
    paddingTop: theme.spacing(0.8),
    paddingBottom: theme.spacing(0.8),
  },
}));

export const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '0.95rem',
  color: theme.palette.text.secondary,
  letterSpacing: 0.8,
  textTransform: 'capitalize',
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  transition: 'background 0.2s',
}));

export const ProductName = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
}));

export const PriceText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
}));

export const TotalPriceText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.primary.main,
}));

export const QuantityText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
}));

export const NoDiscountText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const ProductsGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
  gap: theme.spacing(2),
}));

export const ProductGridCard = styled(Card)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  borderRadius: theme.spacing(2),
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  transition: 'box-shadow 0.2s ease, transform 0.2s ease',
  '&:hover': {
    boxShadow: '0 6px 18px rgba(0, 0, 0, 0.16)',
    transform: 'translateY(-2px)',
  },
}));

export const ProductGridImageArea = styled(Box)(({ theme }) => ({
  position: 'relative',
  aspectRatio: '1 / 1',
  overflow: 'hidden',
  backgroundColor: theme.palette.grey[100],
}));

export const ProductGridImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
});

export const ProductGridExpandButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(0.75),
  right: theme.spacing(0.75),
  zIndex: 2,
  padding: theme.spacing(0.5),
  color: theme.palette.common.white,
  backgroundColor: alpha('#000', 0.45),
  '&:hover': {
    backgroundColor: alpha('#000', 0.65),
  },
}));

export const ProductGridContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  padding: theme.spacing(1, 1.25, 1.25),
}));
